export const locales = ["ru"] as const;
export const default_locale = "ru";
export const localePrefix = "as-needed";
